export default __webpack_public_path__ + "static/media/logomenu_b.8803f63f.png";